const styles = (theme) => ({
  formContainer: {
    paddingTop: "0px",
    paddingBottom: "30px",
    // width: "60ch",
    // margin: "auto",
    textAlign: "center",
    marginLeft: 12,
    maxWidth: 300,
    [theme.breakpoints.up("md")]: {
      maxWidth: 500,
    },
  },
  card: {
    marginLeft: 32,
    height: 40,
    width: 40,
  },
  appBar: {
    backgroundColor: theme.palette.darkGrey.main,
    paddingBottom: 24,
    paddingTop: 24,
  },
  container: {
    margin: "60px auto 0",
    padding: 30,
    borderRadius: 22,
    width: "calc(100% - 32px)",
    maxWidth: 500,
    boxSizing: "border-box",
  },
  backgroundImg: {
    paddingTop: 88,
    backgroundImage: `linear-gradient(rgba(255, 255, 255, 0.8), rgba(255, 255, 255, 0.8)), url('/background-login.png')`,
    backgroundSize: "cover",
    backgroundPosition: "center top",
    minHeight: "100vh",
    backgroundRepeat: "repeat-y",
  },
  cardMedia: {
    marginBottom: 8,
  },
  title: {
    fontSize: 28,
    fontWeight: 700,
    lineHeight: 1.25,
    [theme.breakpoints.down("xs")]: {
      fontSize: 22,
    },
    marginBottom: 20,
    marginTop: 20,
    color: "white",
    textAlign: "center",
  },
  subtitle: {
    textAlign: "center",
    fontSize: 16,
    fontWeight: 500,
    color: "white",
  },
});

export default styles;
